export const validateFileSize = (filesSize, maxFilesSize) => {
  return Math.round(filesSize / (1024 * 1024)) < maxFilesSize
}
